module.exports = __webpack_public_path__ + "static/media/Relative-Bold-Web.beba2461.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Relative-Bold-Web.ttf
// module id = 742
// module chunks = 0